import { get_image_url } from "../api";
import { IconEdit, IconPhotoScan } from "@tabler/icons-react";
function Gallery({ items, setEditItem }) {
  return (
    <div className="m-4 p-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {items.map((item) => (
        <div
          key={item.item_id}
          className="relative h-full w-full flex items-stretch"
        >
          {item.enable_status !== 0 && (
            <div className="absolute inset-0 z-10 bg-red-200 opacity-25" />
          )}
          <div
            key={item.item_id}
            className="w-full grid-item p-4 border rounded-md"
          >
            <div>
              {item.images.length > 0 ? (
                <img
                  className="w-full h-24 object-cover rounded-md"
                  alt={item.item_name}
                  src={get_image_url(item.images[0])}
                />
              ) : (
                <div className="w-100 h-24 border rounded-md flex justify-center items-center">
                  <IconPhotoScan className="h-8 w-8" />
                </div>
              )}
            </div>
            <div className="text-lg font-medium pt-2">{item.item_name}</div>
            <div className="text-sm font-medium">{item.item_description}</div>
          </div>
          <div className="absolute top-4 right-4 z-20">
            <button
              onClick={() => setEditItem(item)}
              className="hover:bg-slate-200 p-2 bg-opacity-50 rounded-md"
            >
              <IconEdit className="w-8 h-8 " />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
export default Gallery;
